import React from 'react';
import { Button } from 'antd';


import EditBrandModal from './edit-brand-modal';

class EditBrandButton extends React.Component {
    render() {
        return (
            <Button.Group size="small">
                <Button 
                    onClick={this.openModal}
                    type="primary"
                    >
                    Edit
                </Button>

                <Button onClick={this.deleteBrand} type="danger" key="remove">Remove</Button>

                {this.renderEditBrandModal()}
            </Button.Group>
            

        )
    }

    renderEditBrandModal = () => {
        const { isEditModalOpen } = this.state;
        const { brand } = this.props;

        if(!isEditModalOpen) {
            return null;
        }
        console.log("openModal")
        return (
            <EditBrandModal
                isEditModalOpen={isEditModalOpen} 
                onCloseModal={this.closeModal}
                brand={brand}
                />
        )

    }
    state = { 
        isEditModalOpen: false
    }


    openModal = () => {
        console.log("open")
        this.setState({
            isEditModalOpen: true
        })

        this.renderEditBrandModal()
    }

    closeModal = () => {
        console.log("close modal")
        this.setState({
            isEditModalOpen: false
        })
    }

    deleteBrand = () => {
        this.props.handleConfirmDelete()
    }
}

export default EditBrandButton;


// WEBPACK FOOTER //
// ./src/components/brands/edit-brand-button.js